import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
const bonuses = [{
  number: '01',
  tag: 'BONO #1',
  title: 'TALLA PERFECTA EN 3 MIN',
  subtitle: 'Guía Express de Medición + Ajuste Triple (Sin Errarle)',
  hook: 'La razón número uno por la que las fajas "no funcionan" no es la faja.',
  hookCont: 'Es el talle mal elegido.',
  description: 'Esta mini guía te muestra exactamente cómo medirte en 3 minutos, cuál es tu talle real (con tabla incluida) y cómo adaptar tu corset en 7 días sin dolor, sin marcas y sin devoluciones.',
  bullets: ['Método de medición paso a paso (incluso sin cinta métrica)', 'Tabla de talles S al 3XL (con criterio de decisión claro)', 'Protocolo anti-molestias de 7 días (primera hilera → segunda → tercera)', 'Checklist printable "Talla Perfecta"', 'Scripts de WhatsApp para resolver cualquier duda en segundos', 'Los 9 errores típicos que arruinan la experiencia (y cómo evitarlos)'],
  value: '$47.000',
  image: 'https://cdn.magicpatterns.com/uploads/3BYXG15zzBZjBJ3U1F1t7F/fa-01.png',
  alt: 'Bono Talla Perfecta en 3 Min'
}, {
  number: '02',
  tag: 'BONO #2',
  title: 'OUTFIT CONFIDENCE KIT',
  subtitle: 'Looks Reales para Corset (sin marcas, sin bultos, sin "se nota")',
  hook: 'El corset ya te da la silueta.',
  hookCont: 'Ahora necesitás saber qué ponerte encima para que se vea impecable.',
  description: 'Este lookbook digital te muestra 10 outfits reales para usar con tu corset en el día a día (trabajo, salida, home office, casual) y cómo combinar capas y telas para que no se marque nada.',
  bullets: ['La "Regla de la 2da Capa" (la que cambia todo)', 'Checklist anti-marcas en 60 segundos (antes de salir)', 'Lookbook de 10 outfits reales con ocasión de uso', 'Guía de telas AMIGAS vs. telas ENEMIGAS', 'Soluciones express: "se nota el broche / hace bulto / se marca"', 'Armario cápsula de 7 prendas que combinan con todo'],
  value: '$47.000',
  image: 'https://cdn.magicpatterns.com/uploads/5J9N7CW6rmpTKybQuyPWxx/fa-02.png',
  alt: 'Bono Outfit Confidence Kit'
}, {
  number: '03',
  tag: 'BONO #3',
  title: 'RITUAL 10 MIN DE NOCHE',
  subtitle: 'Reset Anti‑Hinchazón + Sueño Profundo',
  hook: '¿Terminás el día con la panza pesada, tensa y sin ganas de nada?',
  hookCont: 'Este ritual nocturno de 10 minutos está diseñado para ayudarte a bajar esa sensación antes de dormir.',
  description: 'No es magia. Es consistencia: respiración + masaje suave + postura de descarga. Simple, rápido y repetible cada noche.',
  bullets: ['Ritual cronometrado de 10 minutos (paso a paso)', 'Técnica de respiración 4–2–6 para bajar estrés rápido', 'Auto-masaje abdominal suave (3 pasos sin dolor)', 'Checklist printable "Reset Nocturno"', 'Tracker de 21 días (sueño / hinchazón / energía)', 'Script de respiración guiada (para leer o grabar como audio)'],
  value: '$47.000',
  image: 'https://cdn.magicpatterns.com/uploads/7ub5rFM4CqFCNiFFREDFZk/fa-03.png',
  alt: 'Bono Ritual 10 Min de Noche'
}];
const valueStack = [{
  icon: '🪝',
  label: 'Faja Corset Premium (S–3XL)',
  value: '$49.990'
}, {
  icon: '📱',
  label: 'Protocolo Digital Vientre Plano 21D',
  value: '$47.000'
}, {
  icon: '🎁',
  label: 'BONO #1: Talla Perfecta en 3 Min',
  value: '$47.000'
}, {
  icon: '🎁',
  label: 'BONO #2: Outfit Confidence Kit',
  value: '$47.000'
}, {
  icon: '🎁',
  label: 'BONO #3: Ritual 10 Min de Noche',
  value: '$47.000'
}];
export function BonusSection() {
  return <section className="py-24 px-4 md:px-8 bg-brown-deep overflow-hidden" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        {/* Transition copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-35">
          <p className="text-gold font-bold tracking-widest text-sm uppercase mb-4" data-id="element-36">
            PERO ESPERATE…
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-37">
            Lo que recibís con tu Kit
            <br data-id="element-38" />
            <span className="italic text-gold" data-id="element-39">no termina ahí.</span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto leading-relaxed mb-4" data-id="element-40">
            Cuando decidís llevar tu corset hoy, quiero asegurarme de que{' '}
            <strong className="text-white" data-id="element-41">no pierdas ni un solo día</strong>{' '}
            por dudas, por errores de talle o por no saber cómo combinar tu
            ropa.
          </p>
          <p className="text-white/70 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-42">
            Por eso armé{' '}
            <strong className="text-gold" data-id="element-43">3 bonos digitales</strong> que
            normalmente vendería por separado, y que hoy te regalo completamente{' '}
            <strong className="text-white" data-id="element-44">gratis</strong> con tu compra.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-8 mb-16" data-id="element-45">
          {bonuses.map((bonus, index) => <motion.div key={bonus.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-white/5 border border-gold/20 rounded-3xl overflow-hidden" data-id="element-46">
              <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-0" data-id="element-47">
                {/* Image */}
                <div className="relative aspect-[4/3] md:aspect-auto overflow-hidden bg-black" data-id="element-48">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-full object-cover opacity-90" data-id="element-49" />
                  <div className="absolute top-4 left-4 bg-gold text-brown-deep text-xs font-bold px-3 py-1 rounded-full tracking-widest" data-id="element-50">
                    {bonus.tag}
                  </div>
                  <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-sm border border-gold/30 px-3 py-1 rounded-full" data-id="element-51">
                    <span className="text-white/50 text-xs line-through mr-1" data-id="element-52">
                      {bonus.value}
                    </span>
                    <span className="text-gold text-xs font-bold" data-id="element-53">GRATIS</span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 md:p-8" data-id="element-54">
                  <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1" data-id="element-55">
                    {bonus.title}
                  </h3>
                  <p className="text-gold/80 text-sm font-medium mb-4" data-id="element-56">
                    {bonus.subtitle}
                  </p>
                  <p className="text-white/60 italic text-sm mb-1" data-id="element-57">
                    {bonus.hook}
                  </p>
                  <p className="text-white/80 text-sm mb-4" data-id="element-58">{bonus.hookCont}</p>
                  <p className="text-white/70 text-sm leading-relaxed mb-5" data-id="element-59">
                    {bonus.description}
                  </p>
                  <ul className="space-y-2" data-id="element-60">
                    {bonus.bullets.map((b, i) => <li key={i} className="flex items-start gap-2 text-sm text-white/70" data-id="element-61">
                        <Check className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" data-id="element-62" />
                        <span data-id="element-63">{b}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Value Stack Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-gold/20 rounded-3xl overflow-hidden mb-10" data-id="element-64">
          <div className="bg-gold/10 border-b border-gold/20 px-6 py-4 text-center" data-id="element-65">
            <p className="text-gold font-bold tracking-widest text-sm uppercase" data-id="element-66">
              Resumiendo todo lo que recibís hoy
            </p>
          </div>
          <div className="p-6" data-id="element-67">
            <div className="space-y-3 mb-6" data-id="element-68">
              {valueStack.map((item, i) => <div key={i} className="flex items-center justify-between py-2 border-b border-white/10" data-id="element-69">
                  <div className="flex items-center gap-3" data-id="element-70">
                    <span className="text-xl" data-id="element-71">{item.icon}</span>
                    <span className="text-white/80 text-sm" data-id="element-72">{item.label}</span>
                  </div>
                  <span className="text-white/50 text-sm font-medium" data-id="element-73">
                    {item.value}
                  </span>
                </div>)}
            </div>

            {/* Total vs Price */}
            <div className="flex items-center justify-between py-3 border-t-2 border-gold/30 mb-3" data-id="element-74">
              <span className="text-white font-bold text-lg" data-id="element-75">
                💰 VALOR TOTAL DEL KIT
              </span>
              <span className="text-white/50 line-through text-lg font-bold" data-id="element-76">
                $237.990
              </span>
            </div>
            <div className="flex items-center justify-between py-3 bg-coral/20 rounded-xl px-4" data-id="element-77">
              <span className="text-white font-bold text-xl" data-id="element-78">
                🔥 Precio de Lanzamiento
              </span>
              <span className="text-coral font-bold text-3xl" data-id="element-79">$49.990</span>
            </div>
          </div>
        </motion.div>

        {/* Closing copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-80">
          <p className="text-white/70 text-lg leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-81">
            Todo eso por{' '}
            <strong className="text-coral text-2xl" data-id="element-82">$49.990</strong>.<br data-id="element-83" />
            No $237.990. No $150.000. No $80.000.
          </p>
          <p className="text-white/70 text-lg leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-84">
            El acceso a los 3 bonos digitales es{' '}
            <strong className="text-white" data-id="element-85">inmediato</strong> — llegán por email
            apenas confirmás la compra, sin esperar el envío físico.
          </p>
          <p className="text-white/60 text-base leading-relaxed max-w-xl mx-auto mb-8" data-id="element-86">
            Una sola sesión de drenaje linfático en Argentina cuesta más que
            todo este kit.
            <br data-id="element-87" />Y esa sesión te dura un día.{' '}
            <strong className="text-white" data-id="element-88">
              Este kit te dura para siempre.
            </strong>
          </p>

          {/* Urgency */}
          <div className="bg-coral/10 border border-coral/30 rounded-2xl px-6 py-5 max-w-xl mx-auto mb-10" data-id="element-89">
            <p className="text-coral font-bold text-sm uppercase tracking-wide mb-2" data-id="element-90">
              ⚠️ Los bonos son exclusivos del período de lanzamiento
            </p>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-91">
              Cuando termine esta etapa, cada uno se vende por separado. Si
              cerrás esta página hoy sin comprar, no garantizamos que sigan
              disponibles mañana.
            </p>
          </div>

          {/* CTA */}
          <p className="text-white/50 text-sm mb-4 uppercase tracking-widest" data-id="element-92">
            👇 Elegí tu talle y llevate el Kit completo ahora
          </p>
          <a href="#cta-compra" className="inline-flex items-center gap-3 px-10 py-5 bg-coral hover:bg-coral-dark text-white rounded-full font-bold text-lg shadow-xl shadow-coral/30 transition-all duration-300 hover:scale-105 no-underline" data-id="element-93">
            <span data-id="element-94">SÍ, QUIERO MI KIT + LOS 3 BONOS GRATIS</span>
            <ArrowRight className="w-5 h-5" data-id="element-95" />
          </a>
        </motion.div>
      </div>
    </section>;
}